import {
  Component,
  ChangeDetectionStrategy,
  input,
  output,
} from '@angular/core';
import {
  Alert,
  AlertAction,
} from '@surface-elements/shared/alert-system/domain';

@Component({
  selector: 'app-alert-item',
  templateUrl: './alert-item.component.html',
  styleUrls: ['./alert-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertItemComponent {
  readonly alert = input.required<Alert>();
  readonly dismiss = output<string>();
  readonly action = output<AlertAction>();

  handleDismiss(): void {
    this.dismiss.emit(this.alert().id);
  }

  handleAction(action: AlertAction): void {
    this.action.emit(action);
  }

  getActionClass(style?: string): string {
    const baseClass = 'btn btn-sm';
    switch (style) {
      case 'primary':
        return `${baseClass} btn-primary`;
      case 'secondary':
        return `${baseClass} btn-secondary`;
      case 'link':
        return `${baseClass} btn-link`;
      default:
        return `${baseClass} btn-outline-primary`;
    }
  }
}
